import { trackPageView, initScrollAnimations } from '../lib';

export function initVastuServiceLPPage(): void {
  console.log('Initializing vastu service LP page');
  initScrollAnimations();
  trackPageView();
}

if (typeof window !== 'undefined') {
  document.addEventListener('DOMContentLoaded', initVastuServiceLPPage);
}
